<template>
	<div class="section-title" :class="componentClass">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 text-center">
					<span class="section-title-line"></span>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SectionTitle',
	props: {
		componentClass: {
			type: String,
			default: '',
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/partials/SectionTitle.vue